var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

require("core-js/modules/esnext.global-this.js");

!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).prettierPlugins = e.prettierPlugins || {}, e.prettierPlugins.graphql = n());
}(this, function () {
  "use strict";

  var e = function e(_e, n) {
    var t = new SyntaxError(_e + " (" + n.start.line + ":" + n.start.column + ")");
    return t.loc = n, t;
  };

  var n = {
    hasPragma: function hasPragma(e) {
      return /^\s*#[^\S\n]*@(format|prettier)\s*(\n|$)/.test(e);
    },
    insertPragma: function insertPragma(e) {
      return "# @format\n\n" + e;
    }
  };
  var t = {
    locStart: function locStart(e) {
      return "number" == typeof e.start ? e.start : e.loc && e.loc.start;
    },
    locEnd: function locEnd(e) {
      return "number" == typeof e.end ? e.end : e.loc && e.loc.end;
    }
  };

  function i(e, n, t) {
    return e(t = {
      path: n,
      exports: {},
      require: function require(e, n) {
        return function () {
          throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == n && t.path);
      }
    }, t.exports), t.exports;
  }

  var r = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.SYMBOL_TO_STRING_TAG = n.SYMBOL_ASYNC_ITERATOR = n.SYMBOL_ITERATOR = void 0;
    var t = "function" == typeof Symbol && null != Symbol.iterator ? Symbol.iterator : "@@iterator";
    n.SYMBOL_ITERATOR = t;
    var i = "function" == typeof Symbol && null != Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
    n.SYMBOL_ASYNC_ITERATOR = i;
    var r = "function" == typeof Symbol && null != Symbol.toStringTag ? Symbol.toStringTag : "@@toStringTag";
    n.SYMBOL_TO_STRING_TAG = r;
  }),
      o = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.default = void 0;
    var t = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : void 0;
    n.default = t;
  }),
      a = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.default = function (e) {
      return a(e, []);
    };
    var t,
        i = (t = o) && t.__esModule ? t : {
      default: t
    };

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function a(e, n) {
      switch (r(e)) {
        case "string":
          return JSON.stringify(e);

        case "function":
          return e.name ? "[function ".concat(e.name, "]") : "[function]";

        case "object":
          return null === e ? "null" : function (e, n) {
            if (-1 !== n.indexOf(e)) return "[Circular]";

            var t = [].concat(n, [e]),
                r = function (e) {
              var n = e[String(i.default)];
              if ("function" == typeof n) return n;
              if ("function" == typeof e.inspect) return e.inspect;
            }(e);

            if (void 0 !== r) {
              var o = r.call(e);
              if (o !== e) return "string" == typeof o ? o : a(o, t);
            } else if (Array.isArray(e)) return function (e, n) {
              if (0 === e.length) return "[]";
              if (n.length > 2) return "[Array]";

              for (var t = Math.min(10, e.length), i = e.length - t, r = [], o = 0; o < t; ++o) {
                r.push(a(e[o], n));
              }

              1 === i ? r.push("... 1 more item") : i > 1 && r.push("... ".concat(i, " more items"));
              return "[" + r.join(", ") + "]";
            }(e, t);

            return function (e, n) {
              var t = Object.keys(e);
              if (0 === t.length) return "{}";
              if (n.length > 2) return "[" + function (e) {
                var n = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");

                if ("Object" === n && "function" == typeof e.constructor) {
                  var t = e.constructor.name;
                  if ("string" == typeof t && "" !== t) return t;
                }

                return n;
              }(e) + "]";
              return "{ " + t.map(function (t) {
                return t + ": " + a(e[t], n);
              }).join(", ") + " }";
            }(e, t);
          }(e, n);

        default:
          return String(e);
      }
    }
  }),
      s = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.default = function (e, n) {
      if (!Boolean(e)) throw new Error(n);
    };
  }),
      c = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.default = void 0;

    n.default = function (e, n) {
      return e instanceof n;
    };
  }),
      u = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.isSource = function (e) {
      return (0, o.default)(e, d);
    }, n.Source = void 0;
    var t = u(a),
        i = u(s),
        o = u(c);

    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function l(e, n) {
      for (var t = 0; t < n.length; t++) {
        var i = n[t];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    var d = function () {
      function e(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "GraphQL request",
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          line: 1,
          column: 1
        };
        "string" == typeof e || (0, i.default)(0, "Body must be a string. Received: ".concat((0, t.default)(e), ".")), this.body = e, this.name = n, this.locationOffset = r, this.locationOffset.line > 0 || (0, i.default)(0, "line in locationOffset is 1-indexed and must be positive."), this.locationOffset.column > 0 || (0, i.default)(0, "column in locationOffset is 1-indexed and must be positive.");
      }

      var n, o, a;
      return n = e, (o = [{
        key: r.SYMBOL_TO_STRING_TAG,
        get: function get() {
          return "Source";
        }
      }]) && l(n.prototype, o), a && l(n, a), e;
    }();

    n.Source = d;
  }),
      l = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.getLocation = function (e, n) {
      var t,
          i = /\r\n|[\n\r]/g,
          r = 1,
          o = n + 1;

      for (; (t = i.exec(e.body)) && t.index < n;) {
        r += 1, o = n + 1 - (t.index + t[0].length);
      }

      return {
        line: r,
        column: o
      };
    };
  }),
      d = i(function (e, n) {
    function t(e, n) {
      var t = e.locationOffset.column - 1,
          o = r(t) + e.body,
          a = n.line - 1,
          s = e.locationOffset.line - 1,
          c = n.line + s,
          u = 1 === n.line ? t : 0,
          l = n.column + u,
          d = "".concat(e.name, ":").concat(c, ":").concat(l, "\n"),
          p = o.split(/\r\n|[\n\r]/g),
          f = p[a];

      if (f.length > 120) {
        for (var h = Math.floor(l / 80), T = l % 80, v = [], E = 0; E < f.length; E += 80) {
          v.push(f.slice(E, E + 80));
        }

        return d + i([["".concat(c), v[0]]].concat(v.slice(1, h + 1).map(function (e) {
          return ["", e];
        }), [[" ", r(T - 1) + "^"], ["", v[h + 1]]]));
      }

      return d + i([["".concat(c - 1), p[a - 1]], ["".concat(c), f], ["", r(l - 1) + "^"], ["".concat(c + 1), p[a + 1]]]);
    }

    function i(e) {
      var n = e.filter(function (e) {
        e[0];
        return void 0 !== e[1];
      }),
          t = Math.max.apply(Math, n.map(function (e) {
        return e[0].length;
      }));
      return n.map(function (e) {
        var n,
            i = e[0],
            o = e[1];
        return r(t - (n = i).length) + n + (o ? " | " + o : " |");
      }).join("\n");
    }

    function r(e) {
      return Array(e + 1).join(" ");
    }

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.printLocation = function (e) {
      return t(e.source, (0, l.getLocation)(e.source, e.start));
    }, n.printSourceLocation = t;
  }),
      p = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.Kind = void 0;
    var t = Object.freeze({
      NAME: "Name",
      DOCUMENT: "Document",
      OPERATION_DEFINITION: "OperationDefinition",
      VARIABLE_DEFINITION: "VariableDefinition",
      SELECTION_SET: "SelectionSet",
      FIELD: "Field",
      ARGUMENT: "Argument",
      FRAGMENT_SPREAD: "FragmentSpread",
      INLINE_FRAGMENT: "InlineFragment",
      FRAGMENT_DEFINITION: "FragmentDefinition",
      VARIABLE: "Variable",
      INT: "IntValue",
      FLOAT: "FloatValue",
      STRING: "StringValue",
      BOOLEAN: "BooleanValue",
      NULL: "NullValue",
      ENUM: "EnumValue",
      LIST: "ListValue",
      OBJECT: "ObjectValue",
      OBJECT_FIELD: "ObjectField",
      DIRECTIVE: "Directive",
      NAMED_TYPE: "NamedType",
      LIST_TYPE: "ListType",
      NON_NULL_TYPE: "NonNullType",
      SCHEMA_DEFINITION: "SchemaDefinition",
      OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
      SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
      OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
      FIELD_DEFINITION: "FieldDefinition",
      INPUT_VALUE_DEFINITION: "InputValueDefinition",
      INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
      UNION_TYPE_DEFINITION: "UnionTypeDefinition",
      ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
      ENUM_VALUE_DEFINITION: "EnumValueDefinition",
      INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
      DIRECTIVE_DEFINITION: "DirectiveDefinition",
      SCHEMA_EXTENSION: "SchemaExtension",
      SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
      OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
      INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
      UNION_TYPE_EXTENSION: "UnionTypeExtension",
      ENUM_TYPE_EXTENSION: "EnumTypeExtension",
      INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
    });
    n.Kind = t;
  }),
      f = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.TokenKind = void 0;
    var t = Object.freeze({
      SOF: "<SOF>",
      EOF: "<EOF>",
      BANG: "!",
      DOLLAR: "$",
      AMP: "&",
      PAREN_L: "(",
      PAREN_R: ")",
      SPREAD: "...",
      COLON: ":",
      EQUALS: "=",
      AT: "@",
      BRACKET_L: "[",
      BRACKET_R: "]",
      BRACE_L: "{",
      PIPE: "|",
      BRACE_R: "}",
      NAME: "Name",
      INT: "Int",
      FLOAT: "Float",
      STRING: "String",
      BLOCK_STRING: "BlockString",
      COMMENT: "Comment"
    });
    n.TokenKind = t;
  }),
      h = i(function (e, n) {
    function t(e) {
      return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.default = function (e) {
      return "object" == t(e) && null !== e;
    };
  }),
      T = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.printError = y, n.GraphQLError = void 0;
    var t,
        i = (t = h) && t.__esModule ? t : {
      default: t
    };

    function o(e) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function a(e, n) {
      for (var t = 0; t < n.length; t++) {
        var i = n[t];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    function s(e, n) {
      return !n || "object" !== o(n) && "function" != typeof n ? c(e) : n;
    }

    function c(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function u(e) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return (u = function u(e) {
        if (null === e || (t = e, -1 === Function.toString.call(t).indexOf("[native code]"))) return e;
        var t;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== n) {
          if (n.has(e)) return n.get(e);
          n.set(e, i);
        }

        function i() {
          return p(e, arguments, v(this).constructor);
        }

        return i.prototype = Object.create(e.prototype, {
          constructor: {
            value: i,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), T(i, e);
      })(e);
    }

    function p(e, n, t) {
      return (p = f() ? Reflect.construct : function (e, n, t) {
        var i = [null];
        i.push.apply(i, n);
        var r = new (Function.bind.apply(e, i))();
        return t && T(r, t.prototype), r;
      }).apply(null, arguments);
    }

    function f() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }

    function T(e, n) {
      return (T = Object.setPrototypeOf || function (e, n) {
        return e.__proto__ = n, e;
      })(e, n);
    }

    function v(e) {
      return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var E = function (e) {
      !function (e, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), n && T(e, n);
      }(h, e);
      var n,
          t,
          o,
          u,
          d,
          p = (n = h, t = f(), function () {
        var e,
            i = v(n);

        if (t) {
          var r = v(this).constructor;
          e = Reflect.construct(i, arguments, r);
        } else e = i.apply(this, arguments);

        return s(this, e);
      });

      function h(e, n, t, r, o, a, u) {
        var d, f, T, v, E;
        !function (e, n) {
          if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, h), E = p.call(this, e);
        var y,
            N = Array.isArray(n) ? 0 !== n.length ? n : void 0 : n ? [n] : void 0,
            m = t;
        !m && N && (m = null === (y = N[0].loc) || void 0 === y ? void 0 : y.source);
        var k,
            _ = r;
        !_ && N && (_ = N.reduce(function (e, n) {
          return n.loc && e.push(n.loc.start), e;
        }, [])), _ && 0 === _.length && (_ = void 0), r && t ? k = r.map(function (e) {
          return (0, l.getLocation)(t, e);
        }) : N && (k = N.reduce(function (e, n) {
          return n.loc && e.push((0, l.getLocation)(n.loc.source, n.loc.start)), e;
        }, []));
        var O = u;

        if (null == O && null != a) {
          var I = a.extensions;
          (0, i.default)(I) && (O = I);
        }

        return Object.defineProperties(c(E), {
          name: {
            value: "GraphQLError"
          },
          message: {
            value: e,
            enumerable: !0,
            writable: !0
          },
          locations: {
            value: null !== (d = k) && void 0 !== d ? d : void 0,
            enumerable: null != k
          },
          path: {
            value: null != o ? o : void 0,
            enumerable: null != o
          },
          nodes: {
            value: null != N ? N : void 0
          },
          source: {
            value: null !== (f = m) && void 0 !== f ? f : void 0
          },
          positions: {
            value: null !== (T = _) && void 0 !== T ? T : void 0
          },
          originalError: {
            value: a
          },
          extensions: {
            value: null !== (v = O) && void 0 !== v ? v : void 0,
            enumerable: null != O
          }
        }), (null == a ? void 0 : a.stack) ? (Object.defineProperty(c(E), "stack", {
          value: a.stack,
          writable: !0,
          configurable: !0
        }), s(E)) : (Error.captureStackTrace ? Error.captureStackTrace(c(E), h) : Object.defineProperty(c(E), "stack", {
          value: Error().stack,
          writable: !0,
          configurable: !0
        }), E);
      }

      return o = h, (u = [{
        key: "toString",
        value: function value() {
          return y(this);
        }
      }, {
        key: r.SYMBOL_TO_STRING_TAG,
        get: function get() {
          return "Object";
        }
      }]) && a(o.prototype, u), d && a(o, d), h;
    }(u(Error));

    function y(e) {
      var n = e.message;
      if (e.nodes) for (var t = 0, i = e.nodes; t < i.length; t++) {
        var r = i[t];
        r.loc && (n += "\n\n" + (0, d.printLocation)(r.loc));
      } else if (e.source && e.locations) for (var o = 0, a = e.locations; o < a.length; o++) {
        var s = a[o];
        n += "\n\n" + (0, d.printSourceLocation)(e.source, s);
      }
      return n;
    }

    n.GraphQLError = E;
  }),
      v = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.syntaxError = function (e, n, t) {
      return new T.GraphQLError("Syntax Error: ".concat(t), void 0, e, [n]);
    };
  }),
      E = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.default = function (e, n) {
      if (!Boolean(e)) throw new Error(null != n ? n : "Unexpected invariant triggered.");
    };
  }),
      y = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.default = function (e) {
      var n = e.prototype.toJSON;
      "function" == typeof n || (0, t.default)(0), e.prototype.inspect = n, i.default && (e.prototype[i.default] = n);
    };
    var t = r(E),
        i = r(o);

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
  }),
      N = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.isNode = function (e) {
      return null != e && "string" == typeof e.kind;
    }, n.Token = n.Location = void 0;
    var t,
        i = (t = y) && t.__esModule ? t : {
      default: t
    };

    var r = function () {
      function e(e, n, t) {
        this.start = e.start, this.end = n.end, this.startToken = e, this.endToken = n, this.source = t;
      }

      return e.prototype.toJSON = function () {
        return {
          start: this.start,
          end: this.end
        };
      }, e;
    }();

    n.Location = r, (0, i.default)(r);

    var o = function () {
      function e(e, n, t, i, r, o, a) {
        this.kind = e, this.start = n, this.end = t, this.line = i, this.column = r, this.value = a, this.prev = o, this.next = null;
      }

      return e.prototype.toJSON = function () {
        return {
          kind: this.kind,
          value: this.value,
          line: this.line,
          column: this.column
        };
      }, e;
    }();

    n.Token = o, (0, i.default)(o);
  }),
      m = i(function (e, n) {
    function t(e) {
      for (var n = 0; n < e.length; ++n) {
        if (" " !== e[n] && "\t" !== e[n]) return !1;
      }

      return !0;
    }

    function i(e) {
      for (var n, t = !0, i = !0, r = 0, o = null, a = 0; a < e.length; ++a) {
        switch (e.charCodeAt(a)) {
          case 13:
            10 === e.charCodeAt(a + 1) && ++a;

          case 10:
            t = !1, i = !0, r = 0;
            break;

          case 9:
          case 32:
            ++r;
            break;

          default:
            i && !t && (null === o || r < o) && (o = r), i = !1;
        }
      }

      return null !== (n = o) && void 0 !== n ? n : 0;
    }

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.dedentBlockStringValue = function (e) {
      var n = e.split(/\r\n|[\n\r]/g),
          r = i(e);
      if (0 !== r) for (var o = 1; o < n.length; o++) {
        n[o] = n[o].slice(r);
      }
      var a = 0;

      for (; a < n.length && t(n[a]);) {
        ++a;
      }

      var s = n.length;

      for (; s > a && t(n[s - 1]);) {
        --s;
      }

      return n.slice(a, s).join("\n");
    }, n.getBlockStringIndentation = i, n.printBlockString = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          i = -1 === e.indexOf("\n"),
          r = " " === e[0] || "\t" === e[0],
          o = '"' === e[e.length - 1],
          a = "\\" === e[e.length - 1],
          s = !i || o || a || t,
          c = "";
      !s || i && r || (c += "\n" + n);
      c += n ? e.replace(/\n/g, "\n" + n) : e, s && (c += "\n");
      return '"""' + c.replace(/"""/g, '\\"""') + '"""';
    };
  }),
      k = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.isPunctuatorTokenKind = function (e) {
      return e === f.TokenKind.BANG || e === f.TokenKind.DOLLAR || e === f.TokenKind.AMP || e === f.TokenKind.PAREN_L || e === f.TokenKind.PAREN_R || e === f.TokenKind.SPREAD || e === f.TokenKind.COLON || e === f.TokenKind.EQUALS || e === f.TokenKind.AT || e === f.TokenKind.BRACKET_L || e === f.TokenKind.BRACKET_R || e === f.TokenKind.BRACE_L || e === f.TokenKind.PIPE || e === f.TokenKind.BRACE_R;
    }, n.Lexer = void 0;

    var t = function () {
      function e(e) {
        var n = new N.Token(f.TokenKind.SOF, 0, 0, 0, 0, null);
        this.source = e, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
      }

      var n = e.prototype;
      return n.advance = function () {
        return this.lastToken = this.token, this.token = this.lookahead();
      }, n.lookahead = function () {
        var e = this.token;
        if (e.kind !== f.TokenKind.EOF) do {
          var n;
          e = null !== (n = e.next) && void 0 !== n ? n : e.next = r(this, e);
        } while (e.kind === f.TokenKind.COMMENT);
        return e;
      }, e;
    }();

    function i(e) {
      return isNaN(e) ? f.TokenKind.EOF : e < 127 ? JSON.stringify(String.fromCharCode(e)) : "\"\\u".concat(("00" + e.toString(16).toUpperCase()).slice(-4), '"');
    }

    function r(e, n) {
      for (var t = e.source, i = t.body, r = i.length, c = n.end; c < r;) {
        var d = i.charCodeAt(c),
            h = e.line,
            T = 1 + c - e.lineStart;

        switch (d) {
          case 65279:
          case 9:
          case 32:
          case 44:
            ++c;
            continue;

          case 10:
            ++c, ++e.line, e.lineStart = c;
            continue;

          case 13:
            10 === i.charCodeAt(c + 1) ? c += 2 : ++c, ++e.line, e.lineStart = c;
            continue;

          case 33:
            return new N.Token(f.TokenKind.BANG, c, c + 1, h, T, n);

          case 35:
            return a(t, c, h, T, n);

          case 36:
            return new N.Token(f.TokenKind.DOLLAR, c, c + 1, h, T, n);

          case 38:
            return new N.Token(f.TokenKind.AMP, c, c + 1, h, T, n);

          case 40:
            return new N.Token(f.TokenKind.PAREN_L, c, c + 1, h, T, n);

          case 41:
            return new N.Token(f.TokenKind.PAREN_R, c, c + 1, h, T, n);

          case 46:
            if (46 === i.charCodeAt(c + 1) && 46 === i.charCodeAt(c + 2)) return new N.Token(f.TokenKind.SPREAD, c, c + 3, h, T, n);
            break;

          case 58:
            return new N.Token(f.TokenKind.COLON, c, c + 1, h, T, n);

          case 61:
            return new N.Token(f.TokenKind.EQUALS, c, c + 1, h, T, n);

          case 64:
            return new N.Token(f.TokenKind.AT, c, c + 1, h, T, n);

          case 91:
            return new N.Token(f.TokenKind.BRACKET_L, c, c + 1, h, T, n);

          case 93:
            return new N.Token(f.TokenKind.BRACKET_R, c, c + 1, h, T, n);

          case 123:
            return new N.Token(f.TokenKind.BRACE_L, c, c + 1, h, T, n);

          case 124:
            return new N.Token(f.TokenKind.PIPE, c, c + 1, h, T, n);

          case 125:
            return new N.Token(f.TokenKind.BRACE_R, c, c + 1, h, T, n);

          case 34:
            return 34 === i.charCodeAt(c + 1) && 34 === i.charCodeAt(c + 2) ? l(t, c, h, T, n, e) : u(t, c, h, T, n);

          case 45:
          case 48:
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return s(t, c, d, h, T, n);

          case 65:
          case 66:
          case 67:
          case 68:
          case 69:
          case 70:
          case 71:
          case 72:
          case 73:
          case 74:
          case 75:
          case 76:
          case 77:
          case 78:
          case 79:
          case 80:
          case 81:
          case 82:
          case 83:
          case 84:
          case 85:
          case 86:
          case 87:
          case 88:
          case 89:
          case 90:
          case 95:
          case 97:
          case 98:
          case 99:
          case 100:
          case 101:
          case 102:
          case 103:
          case 104:
          case 105:
          case 106:
          case 107:
          case 108:
          case 109:
          case 110:
          case 111:
          case 112:
          case 113:
          case 114:
          case 115:
          case 116:
          case 117:
          case 118:
          case 119:
          case 120:
          case 121:
          case 122:
            return p(t, c, h, T, n);
        }

        throw (0, v.syntaxError)(t, c, o(d));
      }

      var E = e.line,
          y = 1 + c - e.lineStart;
      return new N.Token(f.TokenKind.EOF, r, r, E, y, n);
    }

    function o(e) {
      return e < 32 && 9 !== e && 10 !== e && 13 !== e ? "Cannot contain the invalid character ".concat(i(e), ".") : 39 === e ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : "Cannot parse the unexpected character ".concat(i(e), ".");
    }

    function a(e, n, t, i, r) {
      var o,
          a = e.body,
          s = n;

      do {
        o = a.charCodeAt(++s);
      } while (!isNaN(o) && (o > 31 || 9 === o));

      return new N.Token(f.TokenKind.COMMENT, n, s, t, i, r, a.slice(n + 1, s));
    }

    function s(e, n, t, r, o, a) {
      var s = e.body,
          u = t,
          l = n,
          d = !1;

      if (45 === u && (u = s.charCodeAt(++l)), 48 === u) {
        if ((u = s.charCodeAt(++l)) >= 48 && u <= 57) throw (0, v.syntaxError)(e, l, "Invalid number, unexpected digit after 0: ".concat(i(u), "."));
      } else l = c(e, l, u), u = s.charCodeAt(l);

      if (46 === u && (d = !0, u = s.charCodeAt(++l), l = c(e, l, u), u = s.charCodeAt(l)), 69 !== u && 101 !== u || (d = !0, 43 !== (u = s.charCodeAt(++l)) && 45 !== u || (u = s.charCodeAt(++l)), l = c(e, l, u), u = s.charCodeAt(l)), 46 === u || function (e) {
        return 95 === e || e >= 65 && e <= 90 || e >= 97 && e <= 122;
      }(u)) throw (0, v.syntaxError)(e, l, "Invalid number, expected digit but got: ".concat(i(u), "."));
      return new N.Token(d ? f.TokenKind.FLOAT : f.TokenKind.INT, n, l, r, o, a, s.slice(n, l));
    }

    function c(e, n, t) {
      var r = e.body,
          o = n,
          a = t;

      if (a >= 48 && a <= 57) {
        do {
          a = r.charCodeAt(++o);
        } while (a >= 48 && a <= 57);

        return o;
      }

      throw (0, v.syntaxError)(e, o, "Invalid number, expected digit but got: ".concat(i(a), "."));
    }

    function u(e, n, t, r, o) {
      for (var a, s, c, u, l = e.body, p = n + 1, h = p, T = 0, E = ""; p < l.length && !isNaN(T = l.charCodeAt(p)) && 10 !== T && 13 !== T;) {
        if (34 === T) return E += l.slice(h, p), new N.Token(f.TokenKind.STRING, n, p + 1, t, r, o, E);
        if (T < 32 && 9 !== T) throw (0, v.syntaxError)(e, p, "Invalid character within String: ".concat(i(T), "."));

        if (++p, 92 === T) {
          switch (E += l.slice(h, p - 1), T = l.charCodeAt(p)) {
            case 34:
              E += '"';
              break;

            case 47:
              E += "/";
              break;

            case 92:
              E += "\\";
              break;

            case 98:
              E += "\b";
              break;

            case 102:
              E += "\f";
              break;

            case 110:
              E += "\n";
              break;

            case 114:
              E += "\r";
              break;

            case 116:
              E += "\t";
              break;

            case 117:
              var y = (a = l.charCodeAt(p + 1), s = l.charCodeAt(p + 2), c = l.charCodeAt(p + 3), u = l.charCodeAt(p + 4), d(a) << 12 | d(s) << 8 | d(c) << 4 | d(u));

              if (y < 0) {
                var m = l.slice(p + 1, p + 5);
                throw (0, v.syntaxError)(e, p, "Invalid character escape sequence: \\u".concat(m, "."));
              }

              E += String.fromCharCode(y), p += 4;
              break;

            default:
              throw (0, v.syntaxError)(e, p, "Invalid character escape sequence: \\".concat(String.fromCharCode(T), "."));
          }

          h = ++p;
        }
      }

      throw (0, v.syntaxError)(e, p, "Unterminated string.");
    }

    function l(e, n, t, r, o, a) {
      for (var s = e.body, c = n + 3, u = c, l = 0, d = ""; c < s.length && !isNaN(l = s.charCodeAt(c));) {
        if (34 === l && 34 === s.charCodeAt(c + 1) && 34 === s.charCodeAt(c + 2)) return d += s.slice(u, c), new N.Token(f.TokenKind.BLOCK_STRING, n, c + 3, t, r, o, (0, m.dedentBlockStringValue)(d));
        if (l < 32 && 9 !== l && 10 !== l && 13 !== l) throw (0, v.syntaxError)(e, c, "Invalid character within String: ".concat(i(l), "."));
        10 === l ? (++c, ++a.line, a.lineStart = c) : 13 === l ? (10 === s.charCodeAt(c + 1) ? c += 2 : ++c, ++a.line, a.lineStart = c) : 92 === l && 34 === s.charCodeAt(c + 1) && 34 === s.charCodeAt(c + 2) && 34 === s.charCodeAt(c + 3) ? (d += s.slice(u, c) + '"""', u = c += 4) : ++c;
      }

      throw (0, v.syntaxError)(e, c, "Unterminated string.");
    }

    function d(e) {
      return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
    }

    function p(e, n, t, i, r) {
      for (var o = e.body, a = o.length, s = n + 1, c = 0; s !== a && !isNaN(c = o.charCodeAt(s)) && (95 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122);) {
        ++s;
      }

      return new N.Token(f.TokenKind.NAME, n, s, t, i, r, o.slice(n, s));
    }

    n.Lexer = t;
  }),
      _ = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.DirectiveLocation = void 0;
    var t = Object.freeze({
      QUERY: "QUERY",
      MUTATION: "MUTATION",
      SUBSCRIPTION: "SUBSCRIPTION",
      FIELD: "FIELD",
      FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
      FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
      INLINE_FRAGMENT: "INLINE_FRAGMENT",
      VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
      SCHEMA: "SCHEMA",
      SCALAR: "SCALAR",
      OBJECT: "OBJECT",
      FIELD_DEFINITION: "FIELD_DEFINITION",
      ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
      INTERFACE: "INTERFACE",
      UNION: "UNION",
      ENUM: "ENUM",
      ENUM_VALUE: "ENUM_VALUE",
      INPUT_OBJECT: "INPUT_OBJECT",
      INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
    });
    n.DirectiveLocation = t;
  }),
      O = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.parse = function (e, n) {
      return new t(e, n).parseDocument();
    }, n.parseValue = function (e, n) {
      var i = new t(e, n);
      i.expectToken(f.TokenKind.SOF);
      var r = i.parseValueLiteral(!1);
      return i.expectToken(f.TokenKind.EOF), r;
    }, n.parseType = function (e, n) {
      var i = new t(e, n);
      i.expectToken(f.TokenKind.SOF);
      var r = i.parseTypeReference();
      return i.expectToken(f.TokenKind.EOF), r;
    }, n.Parser = void 0;

    var t = function () {
      function e(e, n) {
        var t = (0, u.isSource)(e) ? e : new u.Source(e);
        this._lexer = new k.Lexer(t), this._options = n;
      }

      var n = e.prototype;
      return n.parseName = function () {
        var e = this.expectToken(f.TokenKind.NAME);
        return {
          kind: p.Kind.NAME,
          value: e.value,
          loc: this.loc(e)
        };
      }, n.parseDocument = function () {
        var e = this._lexer.token;
        return {
          kind: p.Kind.DOCUMENT,
          definitions: this.many(f.TokenKind.SOF, this.parseDefinition, f.TokenKind.EOF),
          loc: this.loc(e)
        };
      }, n.parseDefinition = function () {
        if (this.peek(f.TokenKind.NAME)) switch (this._lexer.token.value) {
          case "query":
          case "mutation":
          case "subscription":
            return this.parseOperationDefinition();

          case "fragment":
            return this.parseFragmentDefinition();

          case "schema":
          case "scalar":
          case "type":
          case "interface":
          case "union":
          case "enum":
          case "input":
          case "directive":
            return this.parseTypeSystemDefinition();

          case "extend":
            return this.parseTypeSystemExtension();
        } else {
          if (this.peek(f.TokenKind.BRACE_L)) return this.parseOperationDefinition();
          if (this.peekDescription()) return this.parseTypeSystemDefinition();
        }
        throw this.unexpected();
      }, n.parseOperationDefinition = function () {
        var e = this._lexer.token;
        if (this.peek(f.TokenKind.BRACE_L)) return {
          kind: p.Kind.OPERATION_DEFINITION,
          operation: "query",
          name: void 0,
          variableDefinitions: [],
          directives: [],
          selectionSet: this.parseSelectionSet(),
          loc: this.loc(e)
        };
        var n,
            t = this.parseOperationType();
        return this.peek(f.TokenKind.NAME) && (n = this.parseName()), {
          kind: p.Kind.OPERATION_DEFINITION,
          operation: t,
          name: n,
          variableDefinitions: this.parseVariableDefinitions(),
          directives: this.parseDirectives(!1),
          selectionSet: this.parseSelectionSet(),
          loc: this.loc(e)
        };
      }, n.parseOperationType = function () {
        var e = this.expectToken(f.TokenKind.NAME);

        switch (e.value) {
          case "query":
            return "query";

          case "mutation":
            return "mutation";

          case "subscription":
            return "subscription";
        }

        throw this.unexpected(e);
      }, n.parseVariableDefinitions = function () {
        return this.optionalMany(f.TokenKind.PAREN_L, this.parseVariableDefinition, f.TokenKind.PAREN_R);
      }, n.parseVariableDefinition = function () {
        var e = this._lexer.token;
        return {
          kind: p.Kind.VARIABLE_DEFINITION,
          variable: this.parseVariable(),
          type: (this.expectToken(f.TokenKind.COLON), this.parseTypeReference()),
          defaultValue: this.expectOptionalToken(f.TokenKind.EQUALS) ? this.parseValueLiteral(!0) : void 0,
          directives: this.parseDirectives(!0),
          loc: this.loc(e)
        };
      }, n.parseVariable = function () {
        var e = this._lexer.token;
        return this.expectToken(f.TokenKind.DOLLAR), {
          kind: p.Kind.VARIABLE,
          name: this.parseName(),
          loc: this.loc(e)
        };
      }, n.parseSelectionSet = function () {
        var e = this._lexer.token;
        return {
          kind: p.Kind.SELECTION_SET,
          selections: this.many(f.TokenKind.BRACE_L, this.parseSelection, f.TokenKind.BRACE_R),
          loc: this.loc(e)
        };
      }, n.parseSelection = function () {
        return this.peek(f.TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
      }, n.parseField = function () {
        var e,
            n,
            t = this._lexer.token,
            i = this.parseName();
        return this.expectOptionalToken(f.TokenKind.COLON) ? (e = i, n = this.parseName()) : n = i, {
          kind: p.Kind.FIELD,
          alias: e,
          name: n,
          arguments: this.parseArguments(!1),
          directives: this.parseDirectives(!1),
          selectionSet: this.peek(f.TokenKind.BRACE_L) ? this.parseSelectionSet() : void 0,
          loc: this.loc(t)
        };
      }, n.parseArguments = function (e) {
        var n = e ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany(f.TokenKind.PAREN_L, n, f.TokenKind.PAREN_R);
      }, n.parseArgument = function () {
        var e = this._lexer.token,
            n = this.parseName();
        return this.expectToken(f.TokenKind.COLON), {
          kind: p.Kind.ARGUMENT,
          name: n,
          value: this.parseValueLiteral(!1),
          loc: this.loc(e)
        };
      }, n.parseConstArgument = function () {
        var e = this._lexer.token;
        return {
          kind: p.Kind.ARGUMENT,
          name: this.parseName(),
          value: (this.expectToken(f.TokenKind.COLON), this.parseValueLiteral(!0)),
          loc: this.loc(e)
        };
      }, n.parseFragment = function () {
        var e = this._lexer.token;
        this.expectToken(f.TokenKind.SPREAD);
        var n = this.expectOptionalKeyword("on");
        return !n && this.peek(f.TokenKind.NAME) ? {
          kind: p.Kind.FRAGMENT_SPREAD,
          name: this.parseFragmentName(),
          directives: this.parseDirectives(!1),
          loc: this.loc(e)
        } : {
          kind: p.Kind.INLINE_FRAGMENT,
          typeCondition: n ? this.parseNamedType() : void 0,
          directives: this.parseDirectives(!1),
          selectionSet: this.parseSelectionSet(),
          loc: this.loc(e)
        };
      }, n.parseFragmentDefinition = function () {
        var e,
            n = this._lexer.token;
        return this.expectKeyword("fragment"), !0 === (null === (e = this._options) || void 0 === e ? void 0 : e.experimentalFragmentVariables) ? {
          kind: p.Kind.FRAGMENT_DEFINITION,
          name: this.parseFragmentName(),
          variableDefinitions: this.parseVariableDefinitions(),
          typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
          directives: this.parseDirectives(!1),
          selectionSet: this.parseSelectionSet(),
          loc: this.loc(n)
        } : {
          kind: p.Kind.FRAGMENT_DEFINITION,
          name: this.parseFragmentName(),
          typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
          directives: this.parseDirectives(!1),
          selectionSet: this.parseSelectionSet(),
          loc: this.loc(n)
        };
      }, n.parseFragmentName = function () {
        if ("on" === this._lexer.token.value) throw this.unexpected();
        return this.parseName();
      }, n.parseValueLiteral = function (e) {
        var n = this._lexer.token;

        switch (n.kind) {
          case f.TokenKind.BRACKET_L:
            return this.parseList(e);

          case f.TokenKind.BRACE_L:
            return this.parseObject(e);

          case f.TokenKind.INT:
            return this._lexer.advance(), {
              kind: p.Kind.INT,
              value: n.value,
              loc: this.loc(n)
            };

          case f.TokenKind.FLOAT:
            return this._lexer.advance(), {
              kind: p.Kind.FLOAT,
              value: n.value,
              loc: this.loc(n)
            };

          case f.TokenKind.STRING:
          case f.TokenKind.BLOCK_STRING:
            return this.parseStringLiteral();

          case f.TokenKind.NAME:
            switch (this._lexer.advance(), n.value) {
              case "true":
                return {
                  kind: p.Kind.BOOLEAN,
                  value: !0,
                  loc: this.loc(n)
                };

              case "false":
                return {
                  kind: p.Kind.BOOLEAN,
                  value: !1,
                  loc: this.loc(n)
                };

              case "null":
                return {
                  kind: p.Kind.NULL,
                  loc: this.loc(n)
                };

              default:
                return {
                  kind: p.Kind.ENUM,
                  value: n.value,
                  loc: this.loc(n)
                };
            }

          case f.TokenKind.DOLLAR:
            if (!e) return this.parseVariable();
        }

        throw this.unexpected();
      }, n.parseStringLiteral = function () {
        var e = this._lexer.token;
        return this._lexer.advance(), {
          kind: p.Kind.STRING,
          value: e.value,
          block: e.kind === f.TokenKind.BLOCK_STRING,
          loc: this.loc(e)
        };
      }, n.parseList = function (e) {
        var n = this,
            t = this._lexer.token;
        return {
          kind: p.Kind.LIST,
          values: this.any(f.TokenKind.BRACKET_L, function () {
            return n.parseValueLiteral(e);
          }, f.TokenKind.BRACKET_R),
          loc: this.loc(t)
        };
      }, n.parseObject = function (e) {
        var n = this,
            t = this._lexer.token;
        return {
          kind: p.Kind.OBJECT,
          fields: this.any(f.TokenKind.BRACE_L, function () {
            return n.parseObjectField(e);
          }, f.TokenKind.BRACE_R),
          loc: this.loc(t)
        };
      }, n.parseObjectField = function (e) {
        var n = this._lexer.token,
            t = this.parseName();
        return this.expectToken(f.TokenKind.COLON), {
          kind: p.Kind.OBJECT_FIELD,
          name: t,
          value: this.parseValueLiteral(e),
          loc: this.loc(n)
        };
      }, n.parseDirectives = function (e) {
        for (var n = []; this.peek(f.TokenKind.AT);) {
          n.push(this.parseDirective(e));
        }

        return n;
      }, n.parseDirective = function (e) {
        var n = this._lexer.token;
        return this.expectToken(f.TokenKind.AT), {
          kind: p.Kind.DIRECTIVE,
          name: this.parseName(),
          arguments: this.parseArguments(e),
          loc: this.loc(n)
        };
      }, n.parseTypeReference = function () {
        var e,
            n = this._lexer.token;
        return this.expectOptionalToken(f.TokenKind.BRACKET_L) ? (e = this.parseTypeReference(), this.expectToken(f.TokenKind.BRACKET_R), e = {
          kind: p.Kind.LIST_TYPE,
          type: e,
          loc: this.loc(n)
        }) : e = this.parseNamedType(), this.expectOptionalToken(f.TokenKind.BANG) ? {
          kind: p.Kind.NON_NULL_TYPE,
          type: e,
          loc: this.loc(n)
        } : e;
      }, n.parseNamedType = function () {
        var e = this._lexer.token;
        return {
          kind: p.Kind.NAMED_TYPE,
          name: this.parseName(),
          loc: this.loc(e)
        };
      }, n.parseTypeSystemDefinition = function () {
        var e = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (e.kind === f.TokenKind.NAME) switch (e.value) {
          case "schema":
            return this.parseSchemaDefinition();

          case "scalar":
            return this.parseScalarTypeDefinition();

          case "type":
            return this.parseObjectTypeDefinition();

          case "interface":
            return this.parseInterfaceTypeDefinition();

          case "union":
            return this.parseUnionTypeDefinition();

          case "enum":
            return this.parseEnumTypeDefinition();

          case "input":
            return this.parseInputObjectTypeDefinition();

          case "directive":
            return this.parseDirectiveDefinition();
        }
        throw this.unexpected(e);
      }, n.peekDescription = function () {
        return this.peek(f.TokenKind.STRING) || this.peek(f.TokenKind.BLOCK_STRING);
      }, n.parseDescription = function () {
        if (this.peekDescription()) return this.parseStringLiteral();
      }, n.parseSchemaDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription();
        this.expectKeyword("schema");
        var t = this.parseDirectives(!0),
            i = this.many(f.TokenKind.BRACE_L, this.parseOperationTypeDefinition, f.TokenKind.BRACE_R);
        return {
          kind: p.Kind.SCHEMA_DEFINITION,
          description: n,
          directives: t,
          operationTypes: i,
          loc: this.loc(e)
        };
      }, n.parseOperationTypeDefinition = function () {
        var e = this._lexer.token,
            n = this.parseOperationType();
        this.expectToken(f.TokenKind.COLON);
        var t = this.parseNamedType();
        return {
          kind: p.Kind.OPERATION_TYPE_DEFINITION,
          operation: n,
          type: t,
          loc: this.loc(e)
        };
      }, n.parseScalarTypeDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription();
        this.expectKeyword("scalar");
        var t = this.parseName(),
            i = this.parseDirectives(!0);
        return {
          kind: p.Kind.SCALAR_TYPE_DEFINITION,
          description: n,
          name: t,
          directives: i,
          loc: this.loc(e)
        };
      }, n.parseObjectTypeDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription();
        this.expectKeyword("type");
        var t = this.parseName(),
            i = this.parseImplementsInterfaces(),
            r = this.parseDirectives(!0),
            o = this.parseFieldsDefinition();
        return {
          kind: p.Kind.OBJECT_TYPE_DEFINITION,
          description: n,
          name: t,
          interfaces: i,
          directives: r,
          fields: o,
          loc: this.loc(e)
        };
      }, n.parseImplementsInterfaces = function () {
        var e;
        if (!this.expectOptionalKeyword("implements")) return [];

        if (!0 === (null === (e = this._options) || void 0 === e ? void 0 : e.allowLegacySDLImplementsInterfaces)) {
          var n = [];
          this.expectOptionalToken(f.TokenKind.AMP);

          do {
            n.push(this.parseNamedType());
          } while (this.expectOptionalToken(f.TokenKind.AMP) || this.peek(f.TokenKind.NAME));

          return n;
        }

        return this.delimitedMany(f.TokenKind.AMP, this.parseNamedType);
      }, n.parseFieldsDefinition = function () {
        var e;
        return !0 === (null === (e = this._options) || void 0 === e ? void 0 : e.allowLegacySDLEmptyFields) && this.peek(f.TokenKind.BRACE_L) && this._lexer.lookahead().kind === f.TokenKind.BRACE_R ? (this._lexer.advance(), this._lexer.advance(), []) : this.optionalMany(f.TokenKind.BRACE_L, this.parseFieldDefinition, f.TokenKind.BRACE_R);
      }, n.parseFieldDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription(),
            t = this.parseName(),
            i = this.parseArgumentDefs();
        this.expectToken(f.TokenKind.COLON);
        var r = this.parseTypeReference(),
            o = this.parseDirectives(!0);
        return {
          kind: p.Kind.FIELD_DEFINITION,
          description: n,
          name: t,
          arguments: i,
          type: r,
          directives: o,
          loc: this.loc(e)
        };
      }, n.parseArgumentDefs = function () {
        return this.optionalMany(f.TokenKind.PAREN_L, this.parseInputValueDef, f.TokenKind.PAREN_R);
      }, n.parseInputValueDef = function () {
        var e = this._lexer.token,
            n = this.parseDescription(),
            t = this.parseName();
        this.expectToken(f.TokenKind.COLON);
        var i,
            r = this.parseTypeReference();
        this.expectOptionalToken(f.TokenKind.EQUALS) && (i = this.parseValueLiteral(!0));
        var o = this.parseDirectives(!0);
        return {
          kind: p.Kind.INPUT_VALUE_DEFINITION,
          description: n,
          name: t,
          type: r,
          defaultValue: i,
          directives: o,
          loc: this.loc(e)
        };
      }, n.parseInterfaceTypeDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription();
        this.expectKeyword("interface");
        var t = this.parseName(),
            i = this.parseImplementsInterfaces(),
            r = this.parseDirectives(!0),
            o = this.parseFieldsDefinition();
        return {
          kind: p.Kind.INTERFACE_TYPE_DEFINITION,
          description: n,
          name: t,
          interfaces: i,
          directives: r,
          fields: o,
          loc: this.loc(e)
        };
      }, n.parseUnionTypeDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription();
        this.expectKeyword("union");
        var t = this.parseName(),
            i = this.parseDirectives(!0),
            r = this.parseUnionMemberTypes();
        return {
          kind: p.Kind.UNION_TYPE_DEFINITION,
          description: n,
          name: t,
          directives: i,
          types: r,
          loc: this.loc(e)
        };
      }, n.parseUnionMemberTypes = function () {
        return this.expectOptionalToken(f.TokenKind.EQUALS) ? this.delimitedMany(f.TokenKind.PIPE, this.parseNamedType) : [];
      }, n.parseEnumTypeDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription();
        this.expectKeyword("enum");
        var t = this.parseName(),
            i = this.parseDirectives(!0),
            r = this.parseEnumValuesDefinition();
        return {
          kind: p.Kind.ENUM_TYPE_DEFINITION,
          description: n,
          name: t,
          directives: i,
          values: r,
          loc: this.loc(e)
        };
      }, n.parseEnumValuesDefinition = function () {
        return this.optionalMany(f.TokenKind.BRACE_L, this.parseEnumValueDefinition, f.TokenKind.BRACE_R);
      }, n.parseEnumValueDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription(),
            t = this.parseName(),
            i = this.parseDirectives(!0);
        return {
          kind: p.Kind.ENUM_VALUE_DEFINITION,
          description: n,
          name: t,
          directives: i,
          loc: this.loc(e)
        };
      }, n.parseInputObjectTypeDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription();
        this.expectKeyword("input");
        var t = this.parseName(),
            i = this.parseDirectives(!0),
            r = this.parseInputFieldsDefinition();
        return {
          kind: p.Kind.INPUT_OBJECT_TYPE_DEFINITION,
          description: n,
          name: t,
          directives: i,
          fields: r,
          loc: this.loc(e)
        };
      }, n.parseInputFieldsDefinition = function () {
        return this.optionalMany(f.TokenKind.BRACE_L, this.parseInputValueDef, f.TokenKind.BRACE_R);
      }, n.parseTypeSystemExtension = function () {
        var e = this._lexer.lookahead();

        if (e.kind === f.TokenKind.NAME) switch (e.value) {
          case "schema":
            return this.parseSchemaExtension();

          case "scalar":
            return this.parseScalarTypeExtension();

          case "type":
            return this.parseObjectTypeExtension();

          case "interface":
            return this.parseInterfaceTypeExtension();

          case "union":
            return this.parseUnionTypeExtension();

          case "enum":
            return this.parseEnumTypeExtension();

          case "input":
            return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(e);
      }, n.parseSchemaExtension = function () {
        var e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("schema");
        var n = this.parseDirectives(!0),
            t = this.optionalMany(f.TokenKind.BRACE_L, this.parseOperationTypeDefinition, f.TokenKind.BRACE_R);
        if (0 === n.length && 0 === t.length) throw this.unexpected();
        return {
          kind: p.Kind.SCHEMA_EXTENSION,
          directives: n,
          operationTypes: t,
          loc: this.loc(e)
        };
      }, n.parseScalarTypeExtension = function () {
        var e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("scalar");
        var n = this.parseName(),
            t = this.parseDirectives(!0);
        if (0 === t.length) throw this.unexpected();
        return {
          kind: p.Kind.SCALAR_TYPE_EXTENSION,
          name: n,
          directives: t,
          loc: this.loc(e)
        };
      }, n.parseObjectTypeExtension = function () {
        var e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("type");
        var n = this.parseName(),
            t = this.parseImplementsInterfaces(),
            i = this.parseDirectives(!0),
            r = this.parseFieldsDefinition();
        if (0 === t.length && 0 === i.length && 0 === r.length) throw this.unexpected();
        return {
          kind: p.Kind.OBJECT_TYPE_EXTENSION,
          name: n,
          interfaces: t,
          directives: i,
          fields: r,
          loc: this.loc(e)
        };
      }, n.parseInterfaceTypeExtension = function () {
        var e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("interface");
        var n = this.parseName(),
            t = this.parseImplementsInterfaces(),
            i = this.parseDirectives(!0),
            r = this.parseFieldsDefinition();
        if (0 === t.length && 0 === i.length && 0 === r.length) throw this.unexpected();
        return {
          kind: p.Kind.INTERFACE_TYPE_EXTENSION,
          name: n,
          interfaces: t,
          directives: i,
          fields: r,
          loc: this.loc(e)
        };
      }, n.parseUnionTypeExtension = function () {
        var e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("union");
        var n = this.parseName(),
            t = this.parseDirectives(!0),
            i = this.parseUnionMemberTypes();
        if (0 === t.length && 0 === i.length) throw this.unexpected();
        return {
          kind: p.Kind.UNION_TYPE_EXTENSION,
          name: n,
          directives: t,
          types: i,
          loc: this.loc(e)
        };
      }, n.parseEnumTypeExtension = function () {
        var e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("enum");
        var n = this.parseName(),
            t = this.parseDirectives(!0),
            i = this.parseEnumValuesDefinition();
        if (0 === t.length && 0 === i.length) throw this.unexpected();
        return {
          kind: p.Kind.ENUM_TYPE_EXTENSION,
          name: n,
          directives: t,
          values: i,
          loc: this.loc(e)
        };
      }, n.parseInputObjectTypeExtension = function () {
        var e = this._lexer.token;
        this.expectKeyword("extend"), this.expectKeyword("input");
        var n = this.parseName(),
            t = this.parseDirectives(!0),
            i = this.parseInputFieldsDefinition();
        if (0 === t.length && 0 === i.length) throw this.unexpected();
        return {
          kind: p.Kind.INPUT_OBJECT_TYPE_EXTENSION,
          name: n,
          directives: t,
          fields: i,
          loc: this.loc(e)
        };
      }, n.parseDirectiveDefinition = function () {
        var e = this._lexer.token,
            n = this.parseDescription();
        this.expectKeyword("directive"), this.expectToken(f.TokenKind.AT);
        var t = this.parseName(),
            i = this.parseArgumentDefs(),
            r = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var o = this.parseDirectiveLocations();
        return {
          kind: p.Kind.DIRECTIVE_DEFINITION,
          description: n,
          name: t,
          arguments: i,
          repeatable: r,
          locations: o,
          loc: this.loc(e)
        };
      }, n.parseDirectiveLocations = function () {
        return this.delimitedMany(f.TokenKind.PIPE, this.parseDirectiveLocation);
      }, n.parseDirectiveLocation = function () {
        var e = this._lexer.token,
            n = this.parseName();
        if (void 0 !== _.DirectiveLocation[n.value]) return n;
        throw this.unexpected(e);
      }, n.loc = function (e) {
        var n;
        if (!0 !== (null === (n = this._options) || void 0 === n ? void 0 : n.noLocation)) return new N.Location(e, this._lexer.lastToken, this._lexer.source);
      }, n.peek = function (e) {
        return this._lexer.token.kind === e;
      }, n.expectToken = function (e) {
        var n = this._lexer.token;
        if (n.kind === e) return this._lexer.advance(), n;
        throw (0, v.syntaxError)(this._lexer.source, n.start, "Expected ".concat(r(e), ", found ").concat(i(n), "."));
      }, n.expectOptionalToken = function (e) {
        var n = this._lexer.token;
        if (n.kind === e) return this._lexer.advance(), n;
      }, n.expectKeyword = function (e) {
        var n = this._lexer.token;
        if (n.kind !== f.TokenKind.NAME || n.value !== e) throw (0, v.syntaxError)(this._lexer.source, n.start, 'Expected "'.concat(e, '", found ').concat(i(n), "."));

        this._lexer.advance();
      }, n.expectOptionalKeyword = function (e) {
        var n = this._lexer.token;
        return n.kind === f.TokenKind.NAME && n.value === e && (this._lexer.advance(), !0);
      }, n.unexpected = function (e) {
        var n = null != e ? e : this._lexer.token;
        return (0, v.syntaxError)(this._lexer.source, n.start, "Unexpected ".concat(i(n), "."));
      }, n.any = function (e, n, t) {
        this.expectToken(e);

        for (var i = []; !this.expectOptionalToken(t);) {
          i.push(n.call(this));
        }

        return i;
      }, n.optionalMany = function (e, n, t) {
        if (this.expectOptionalToken(e)) {
          var i = [];

          do {
            i.push(n.call(this));
          } while (!this.expectOptionalToken(t));

          return i;
        }

        return [];
      }, n.many = function (e, n, t) {
        this.expectToken(e);
        var i = [];

        do {
          i.push(n.call(this));
        } while (!this.expectOptionalToken(t));

        return i;
      }, n.delimitedMany = function (e, n) {
        this.expectOptionalToken(e);
        var t = [];

        do {
          t.push(n.call(this));
        } while (this.expectOptionalToken(e));

        return t;
      }, e;
    }();

    function i(e) {
      var n = e.value;
      return r(e.kind) + (null != n ? ' "'.concat(n, '"') : "");
    }

    function r(e) {
      return (0, k.isPunctuatorTokenKind)(e) ? '"'.concat(e, '"') : e;
    }

    n.Parser = t;
  }),
      I = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.visit = function (e, n) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : r,
          a = void 0,
          c = Array.isArray(e),
          u = [e],
          l = -1,
          d = [],
          p = void 0,
          f = void 0,
          h = void 0,
          T = [],
          v = [],
          E = e;

      do {
        var y = ++l === u.length,
            m = y && 0 !== d.length;

        if (y) {
          if (f = 0 === v.length ? void 0 : T[T.length - 1], p = h, h = v.pop(), m) {
            if (c) p = p.slice();else {
              for (var k = {}, _ = 0, O = Object.keys(p); _ < O.length; _++) {
                var I = O[_];
                k[I] = p[I];
              }

              p = k;
            }

            for (var b = 0, D = 0; D < d.length; D++) {
              var x = d[D][0],
                  A = d[D][1];
              c && (x -= b), c && null === A ? (p.splice(x, 1), b++) : p[x] = A;
            }
          }

          l = a.index, u = a.keys, d = a.edits, c = a.inArray, a = a.prev;
        } else {
          if (f = h ? c ? l : u[l] : void 0, null == (p = h ? h[f] : E)) continue;
          h && T.push(f);
        }

        var S,
            K = void 0;

        if (!Array.isArray(p)) {
          if (!(0, N.isNode)(p)) throw new Error("Invalid AST Node: ".concat((0, i.default)(p), "."));
          var g = s(n, p.kind, y);

          if (g) {
            if ((K = g.call(n, p, f, h, T, v)) === o) break;

            if (!1 === K) {
              if (!y) {
                T.pop();
                continue;
              }
            } else if (void 0 !== K && (d.push([f, K]), !y)) {
              if (!(0, N.isNode)(K)) {
                T.pop();
                continue;
              }

              p = K;
            }
          }
        }

        if (void 0 === K && m && d.push([f, p]), y) T.pop();else a = {
          inArray: c,
          index: l,
          keys: u,
          edits: d,
          prev: a
        }, c = Array.isArray(p), u = c ? p : null !== (S = t[p.kind]) && void 0 !== S ? S : [], l = -1, d = [], h && v.push(h), h = p;
      } while (void 0 !== a);

      0 !== d.length && (E = d[d.length - 1][1]);
      return E;
    }, n.visitInParallel = function (e) {
      var n = new Array(e.length);
      return {
        enter: function enter(t) {
          for (var i = 0; i < e.length; i++) {
            if (null == n[i]) {
              var r = s(e[i], t.kind, !1);

              if (r) {
                var a = r.apply(e[i], arguments);
                if (!1 === a) n[i] = t;else if (a === o) n[i] = o;else if (void 0 !== a) return a;
              }
            }
          }
        },
        leave: function leave(t) {
          for (var i = 0; i < e.length; i++) {
            if (null == n[i]) {
              var r = s(e[i], t.kind, !0);

              if (r) {
                var a = r.apply(e[i], arguments);
                if (a === o) n[i] = o;else if (void 0 !== a && !1 !== a) return a;
              }
            } else n[i] === t && (n[i] = null);
          }
        }
      };
    }, n.getVisitFn = s, n.BREAK = n.QueryDocumentKeys = void 0;
    var t,
        i = (t = a) && t.__esModule ? t : {
      default: t
    };
    var r = {
      Name: [],
      Document: ["definitions"],
      OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
      VariableDefinition: ["variable", "type", "defaultValue", "directives"],
      Variable: ["name"],
      SelectionSet: ["selections"],
      Field: ["alias", "name", "arguments", "directives", "selectionSet"],
      Argument: ["name", "value"],
      FragmentSpread: ["name", "directives"],
      InlineFragment: ["typeCondition", "directives", "selectionSet"],
      FragmentDefinition: ["name", "variableDefinitions", "typeCondition", "directives", "selectionSet"],
      IntValue: [],
      FloatValue: [],
      StringValue: [],
      BooleanValue: [],
      NullValue: [],
      EnumValue: [],
      ListValue: ["values"],
      ObjectValue: ["fields"],
      ObjectField: ["name", "value"],
      Directive: ["name", "arguments"],
      NamedType: ["name"],
      ListType: ["type"],
      NonNullType: ["type"],
      SchemaDefinition: ["description", "directives", "operationTypes"],
      OperationTypeDefinition: ["type"],
      ScalarTypeDefinition: ["description", "name", "directives"],
      ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
      FieldDefinition: ["description", "name", "arguments", "type", "directives"],
      InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
      InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
      UnionTypeDefinition: ["description", "name", "directives", "types"],
      EnumTypeDefinition: ["description", "name", "directives", "values"],
      EnumValueDefinition: ["description", "name", "directives"],
      InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
      DirectiveDefinition: ["description", "name", "arguments", "locations"],
      SchemaExtension: ["directives", "operationTypes"],
      ScalarTypeExtension: ["name", "directives"],
      ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
      InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
      UnionTypeExtension: ["name", "directives", "types"],
      EnumTypeExtension: ["name", "directives", "values"],
      InputObjectTypeExtension: ["name", "directives", "fields"]
    };
    n.QueryDocumentKeys = r;
    var o = Object.freeze({});

    function s(e, n, t) {
      var i = e[n];

      if (i) {
        if (!t && "function" == typeof i) return i;
        var r = t ? i.leave : i.enter;
        if ("function" == typeof r) return r;
      } else {
        var o = t ? e.leave : e.enter;

        if (o) {
          if ("function" == typeof o) return o;
          var a = o[n];
          if ("function" == typeof a) return a;
        }
      }
    }

    n.BREAK = o;
  }),
      b = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.print = function (e) {
      return (0, I.visit)(e, {
        leave: t
      });
    };
    var t = {
      Name: function Name(e) {
        return e.value;
      },
      Variable: function Variable(e) {
        return "$" + e.name;
      },
      Document: function Document(e) {
        return r(e.definitions, "\n\n") + "\n";
      },
      OperationDefinition: function OperationDefinition(e) {
        var n = e.operation,
            t = e.name,
            i = a("(", r(e.variableDefinitions, ", "), ")"),
            o = r(e.directives, " "),
            s = e.selectionSet;
        return t || o || i || "query" !== n ? r([n, r([t, i]), o, s], " ") : s;
      },
      VariableDefinition: function VariableDefinition(e) {
        var n = e.variable,
            t = e.type,
            i = e.defaultValue,
            o = e.directives;
        return n + ": " + t + a(" = ", i) + a(" ", r(o, " "));
      },
      SelectionSet: function SelectionSet(e) {
        return o(e.selections);
      },
      Field: function Field(e) {
        var n = e.alias,
            t = e.name,
            i = e.arguments,
            o = e.directives,
            c = e.selectionSet,
            u = a("", n, ": ") + t,
            l = u + a("(", r(i, ", "), ")");
        return l.length > 80 && (l = u + a("(\n", s(r(i, "\n")), "\n)")), r([l, r(o, " "), c], " ");
      },
      Argument: function Argument(e) {
        return e.name + ": " + e.value;
      },
      FragmentSpread: function FragmentSpread(e) {
        return "..." + e.name + a(" ", r(e.directives, " "));
      },
      InlineFragment: function InlineFragment(e) {
        var n = e.typeCondition,
            t = e.directives,
            i = e.selectionSet;
        return r(["...", a("on ", n), r(t, " "), i], " ");
      },
      FragmentDefinition: function FragmentDefinition(e) {
        var n = e.name,
            t = e.typeCondition,
            i = e.variableDefinitions,
            o = e.directives,
            s = e.selectionSet;
        return "fragment ".concat(n).concat(a("(", r(i, ", "), ")"), " ") + "on ".concat(t, " ").concat(a("", r(o, " "), " ")) + s;
      },
      IntValue: function IntValue(e) {
        return e.value;
      },
      FloatValue: function FloatValue(e) {
        return e.value;
      },
      StringValue: function StringValue(e, n) {
        var t = e.value;
        return e.block ? (0, m.printBlockString)(t, "description" === n ? "" : "  ") : JSON.stringify(t);
      },
      BooleanValue: function BooleanValue(e) {
        return e.value ? "true" : "false";
      },
      NullValue: function NullValue() {
        return "null";
      },
      EnumValue: function EnumValue(e) {
        return e.value;
      },
      ListValue: function ListValue(e) {
        return "[" + r(e.values, ", ") + "]";
      },
      ObjectValue: function ObjectValue(e) {
        return "{" + r(e.fields, ", ") + "}";
      },
      ObjectField: function ObjectField(e) {
        return e.name + ": " + e.value;
      },
      Directive: function Directive(e) {
        return "@" + e.name + a("(", r(e.arguments, ", "), ")");
      },
      NamedType: function NamedType(e) {
        return e.name;
      },
      ListType: function ListType(e) {
        return "[" + e.type + "]";
      },
      NonNullType: function NonNullType(e) {
        return e.type + "!";
      },
      SchemaDefinition: i(function (e) {
        var n = e.directives,
            t = e.operationTypes;
        return r(["schema", r(n, " "), o(t)], " ");
      }),
      OperationTypeDefinition: function OperationTypeDefinition(e) {
        return e.operation + ": " + e.type;
      },
      ScalarTypeDefinition: i(function (e) {
        return r(["scalar", e.name, r(e.directives, " ")], " ");
      }),
      ObjectTypeDefinition: i(function (e) {
        var n = e.name,
            t = e.interfaces,
            i = e.directives,
            s = e.fields;
        return r(["type", n, a("implements ", r(t, " & ")), r(i, " "), o(s)], " ");
      }),
      FieldDefinition: i(function (e) {
        var n = e.name,
            t = e.arguments,
            i = e.type,
            o = e.directives;
        return n + (u(t) ? a("(\n", s(r(t, "\n")), "\n)") : a("(", r(t, ", "), ")")) + ": " + i + a(" ", r(o, " "));
      }),
      InputValueDefinition: i(function (e) {
        var n = e.name,
            t = e.type,
            i = e.defaultValue,
            o = e.directives;
        return r([n + ": " + t, a("= ", i), r(o, " ")], " ");
      }),
      InterfaceTypeDefinition: i(function (e) {
        var n = e.name,
            t = e.interfaces,
            i = e.directives,
            s = e.fields;
        return r(["interface", n, a("implements ", r(t, " & ")), r(i, " "), o(s)], " ");
      }),
      UnionTypeDefinition: i(function (e) {
        var n = e.name,
            t = e.directives,
            i = e.types;
        return r(["union", n, r(t, " "), i && 0 !== i.length ? "= " + r(i, " | ") : ""], " ");
      }),
      EnumTypeDefinition: i(function (e) {
        var n = e.name,
            t = e.directives,
            i = e.values;
        return r(["enum", n, r(t, " "), o(i)], " ");
      }),
      EnumValueDefinition: i(function (e) {
        return r([e.name, r(e.directives, " ")], " ");
      }),
      InputObjectTypeDefinition: i(function (e) {
        var n = e.name,
            t = e.directives,
            i = e.fields;
        return r(["input", n, r(t, " "), o(i)], " ");
      }),
      DirectiveDefinition: i(function (e) {
        var n = e.name,
            t = e.arguments,
            i = e.repeatable,
            o = e.locations;
        return "directive @" + n + (u(t) ? a("(\n", s(r(t, "\n")), "\n)") : a("(", r(t, ", "), ")")) + (i ? " repeatable" : "") + " on " + r(o, " | ");
      }),
      SchemaExtension: function SchemaExtension(e) {
        var n = e.directives,
            t = e.operationTypes;
        return r(["extend schema", r(n, " "), o(t)], " ");
      },
      ScalarTypeExtension: function ScalarTypeExtension(e) {
        return r(["extend scalar", e.name, r(e.directives, " ")], " ");
      },
      ObjectTypeExtension: function ObjectTypeExtension(e) {
        var n = e.name,
            t = e.interfaces,
            i = e.directives,
            s = e.fields;
        return r(["extend type", n, a("implements ", r(t, " & ")), r(i, " "), o(s)], " ");
      },
      InterfaceTypeExtension: function InterfaceTypeExtension(e) {
        var n = e.name,
            t = e.interfaces,
            i = e.directives,
            s = e.fields;
        return r(["extend interface", n, a("implements ", r(t, " & ")), r(i, " "), o(s)], " ");
      },
      UnionTypeExtension: function UnionTypeExtension(e) {
        var n = e.name,
            t = e.directives,
            i = e.types;
        return r(["extend union", n, r(t, " "), i && 0 !== i.length ? "= " + r(i, " | ") : ""], " ");
      },
      EnumTypeExtension: function EnumTypeExtension(e) {
        var n = e.name,
            t = e.directives,
            i = e.values;
        return r(["extend enum", n, r(t, " "), o(i)], " ");
      },
      InputObjectTypeExtension: function InputObjectTypeExtension(e) {
        var n = e.name,
            t = e.directives,
            i = e.fields;
        return r(["extend input", n, r(t, " "), o(i)], " ");
      }
    };

    function i(e) {
      return function (n) {
        return r([n.description, e(n)], "\n");
      };
    }

    function r(e) {
      var n,
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
      return null !== (n = null == e ? void 0 : e.filter(function (e) {
        return e;
      }).join(t)) && void 0 !== n ? n : "";
    }

    function o(e) {
      return a("{\n", s(r(e, "\n")), "\n}");
    }

    function a(e, n) {
      var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
      return null != n && "" !== n ? e + n + t : "";
    }

    function s(e) {
      return a("  ", e.replace(/\n/g, "\n  "));
    }

    function c(e) {
      return -1 !== e.indexOf("\n");
    }

    function u(e) {
      return null != e && e.some(c);
    }
  }),
      D = i(function (e, n) {
    function t(e) {
      return e.kind === p.Kind.OPERATION_DEFINITION || e.kind === p.Kind.FRAGMENT_DEFINITION;
    }

    function i(e) {
      return e.kind === p.Kind.SCHEMA_DEFINITION || r(e) || e.kind === p.Kind.DIRECTIVE_DEFINITION;
    }

    function r(e) {
      return e.kind === p.Kind.SCALAR_TYPE_DEFINITION || e.kind === p.Kind.OBJECT_TYPE_DEFINITION || e.kind === p.Kind.INTERFACE_TYPE_DEFINITION || e.kind === p.Kind.UNION_TYPE_DEFINITION || e.kind === p.Kind.ENUM_TYPE_DEFINITION || e.kind === p.Kind.INPUT_OBJECT_TYPE_DEFINITION;
    }

    function o(e) {
      return e.kind === p.Kind.SCHEMA_EXTENSION || a(e);
    }

    function a(e) {
      return e.kind === p.Kind.SCALAR_TYPE_EXTENSION || e.kind === p.Kind.OBJECT_TYPE_EXTENSION || e.kind === p.Kind.INTERFACE_TYPE_EXTENSION || e.kind === p.Kind.UNION_TYPE_EXTENSION || e.kind === p.Kind.ENUM_TYPE_EXTENSION || e.kind === p.Kind.INPUT_OBJECT_TYPE_EXTENSION;
    }

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.isDefinitionNode = function (e) {
      return t(e) || i(e) || o(e);
    }, n.isExecutableDefinitionNode = t, n.isSelectionNode = function (e) {
      return e.kind === p.Kind.FIELD || e.kind === p.Kind.FRAGMENT_SPREAD || e.kind === p.Kind.INLINE_FRAGMENT;
    }, n.isValueNode = function (e) {
      return e.kind === p.Kind.VARIABLE || e.kind === p.Kind.INT || e.kind === p.Kind.FLOAT || e.kind === p.Kind.STRING || e.kind === p.Kind.BOOLEAN || e.kind === p.Kind.NULL || e.kind === p.Kind.ENUM || e.kind === p.Kind.LIST || e.kind === p.Kind.OBJECT;
    }, n.isTypeNode = function (e) {
      return e.kind === p.Kind.NAMED_TYPE || e.kind === p.Kind.LIST_TYPE || e.kind === p.Kind.NON_NULL_TYPE;
    }, n.isTypeSystemDefinitionNode = i, n.isTypeDefinitionNode = r, n.isTypeSystemExtensionNode = o, n.isTypeExtensionNode = a;
  }),
      x = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "Source", {
      enumerable: !0,
      get: function get() {
        return u.Source;
      }
    }), Object.defineProperty(n, "getLocation", {
      enumerable: !0,
      get: function get() {
        return l.getLocation;
      }
    }), Object.defineProperty(n, "printLocation", {
      enumerable: !0,
      get: function get() {
        return d.printLocation;
      }
    }), Object.defineProperty(n, "printSourceLocation", {
      enumerable: !0,
      get: function get() {
        return d.printSourceLocation;
      }
    }), Object.defineProperty(n, "Kind", {
      enumerable: !0,
      get: function get() {
        return p.Kind;
      }
    }), Object.defineProperty(n, "TokenKind", {
      enumerable: !0,
      get: function get() {
        return f.TokenKind;
      }
    }), Object.defineProperty(n, "Lexer", {
      enumerable: !0,
      get: function get() {
        return k.Lexer;
      }
    }), Object.defineProperty(n, "parse", {
      enumerable: !0,
      get: function get() {
        return O.parse;
      }
    }), Object.defineProperty(n, "parseValue", {
      enumerable: !0,
      get: function get() {
        return O.parseValue;
      }
    }), Object.defineProperty(n, "parseType", {
      enumerable: !0,
      get: function get() {
        return O.parseType;
      }
    }), Object.defineProperty(n, "print", {
      enumerable: !0,
      get: function get() {
        return b.print;
      }
    }), Object.defineProperty(n, "visit", {
      enumerable: !0,
      get: function get() {
        return I.visit;
      }
    }), Object.defineProperty(n, "visitInParallel", {
      enumerable: !0,
      get: function get() {
        return I.visitInParallel;
      }
    }), Object.defineProperty(n, "getVisitFn", {
      enumerable: !0,
      get: function get() {
        return I.getVisitFn;
      }
    }), Object.defineProperty(n, "BREAK", {
      enumerable: !0,
      get: function get() {
        return I.BREAK;
      }
    }), Object.defineProperty(n, "Location", {
      enumerable: !0,
      get: function get() {
        return N.Location;
      }
    }), Object.defineProperty(n, "Token", {
      enumerable: !0,
      get: function get() {
        return N.Token;
      }
    }), Object.defineProperty(n, "isDefinitionNode", {
      enumerable: !0,
      get: function get() {
        return D.isDefinitionNode;
      }
    }), Object.defineProperty(n, "isExecutableDefinitionNode", {
      enumerable: !0,
      get: function get() {
        return D.isExecutableDefinitionNode;
      }
    }), Object.defineProperty(n, "isSelectionNode", {
      enumerable: !0,
      get: function get() {
        return D.isSelectionNode;
      }
    }), Object.defineProperty(n, "isValueNode", {
      enumerable: !0,
      get: function get() {
        return D.isValueNode;
      }
    }), Object.defineProperty(n, "isTypeNode", {
      enumerable: !0,
      get: function get() {
        return D.isTypeNode;
      }
    }), Object.defineProperty(n, "isTypeSystemDefinitionNode", {
      enumerable: !0,
      get: function get() {
        return D.isTypeSystemDefinitionNode;
      }
    }), Object.defineProperty(n, "isTypeDefinitionNode", {
      enumerable: !0,
      get: function get() {
        return D.isTypeDefinitionNode;
      }
    }), Object.defineProperty(n, "isTypeSystemExtensionNode", {
      enumerable: !0,
      get: function get() {
        return D.isTypeSystemExtensionNode;
      }
    }), Object.defineProperty(n, "isTypeExtensionNode", {
      enumerable: !0,
      get: function get() {
        return D.isTypeExtensionNode;
      }
    }), Object.defineProperty(n, "DirectiveLocation", {
      enumerable: !0,
      get: function get() {
        return _.DirectiveLocation;
      }
    });
  }),
      A = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.locatedError = function (e, n, t) {
      var r,
          o = e instanceof Error ? e : new Error("Unexpected error value: " + (0, i.default)(e));
      if (Array.isArray(o.path)) return o;
      return new T.GraphQLError(o.message, null !== (r = o.nodes) && void 0 !== r ? r : n, o.source, o.positions, t, o);
    };
    var t,
        i = (t = a) && t.__esModule ? t : {
      default: t
    };
  }),
      S = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.formatError = function (e) {
      var n;
      e || (0, i.default)(0, "Received null or undefined error.");
      var t = null !== (n = e.message) && void 0 !== n ? n : "An unknown error occurred.",
          r = e.locations,
          o = e.path,
          a = e.extensions;
      return a ? {
        message: t,
        locations: r,
        path: o,
        extensions: a
      } : {
        message: t,
        locations: r,
        path: o
      };
    };
    var t,
        i = (t = s) && t.__esModule ? t : {
      default: t
    };
  }),
      K = i(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "GraphQLError", {
      enumerable: !0,
      get: function get() {
        return T.GraphQLError;
      }
    }), Object.defineProperty(n, "printError", {
      enumerable: !0,
      get: function get() {
        return T.printError;
      }
    }), Object.defineProperty(n, "syntaxError", {
      enumerable: !0,
      get: function get() {
        return v.syntaxError;
      }
    }), Object.defineProperty(n, "locatedError", {
      enumerable: !0,
      get: function get() {
        return A.locatedError;
      }
    }), Object.defineProperty(n, "formatError", {
      enumerable: !0,
      get: function get() {
        return S.formatError;
      }
    });
  });

  var g = n.hasPragma,
      L = t.locStart,
      P = t.locEnd;

  function R(e) {
    if (e && "object" == typeof e) {
      delete e.startToken, delete e.endToken, delete e.prev, delete e.next;

      for (var _n in e) {
        R(e[_n]);
      }
    }

    return e;
  }

  return {
    parsers: {
      graphql: {
        parse: function parse(n) {
          var t = x;

          try {
            var _e2 = function (e, n) {
              var t = {
                allowLegacySDLImplementsInterfaces: !1,
                experimentalFragmentVariables: !0
              };

              try {
                return e(n, t);
              } catch (i) {
                return t.allowLegacySDLImplementsInterfaces = !0, e(n, t);
              }
            }(t.parse, n);

            return _e2.comments = function (e) {
              var n = [],
                  t = e.loc.startToken;
              var i = t.next;

              for (; "<EOF>" !== i.kind;) {
                "Comment" === i.kind && (Object.assign(i, {
                  column: i.column - 1
                }), n.push(i)), i = i.next;
              }

              return n;
            }(_e2), R(_e2), _e2;
          } catch (n) {
            var _t = K.GraphQLError;

            if (n instanceof _t) {
              var _t2 = n.message,
                  _n$locations = _slicedToArray(n.locations, 1),
                  _i = _n$locations[0];

              throw e(_t2, {
                start: _i
              });
            }

            throw n;
          }
        },
        astFormat: "graphql",
        hasPragma: g,
        locStart: L,
        locEnd: P
      }
    }
  };
});